import './index.scss'

const AnimatedLetters = ({ letterClass, strArray, idx }) => {
  // Group letters into words so lines wrap only between words, never mid-word
  const groups = []
  strArray.forEach((char, i) => {
    const last = groups[groups.length - 1]
    if (char !== ' ' && last && last[0].char !== ' ') last.push({ char, i })
    else groups.push([{ char, i }])
  })

  const letter = ({ char, i }) => (
    <span key={char + i} className={`${letterClass} _${i + idx}`}>
      {char}
    </span>
  )

  return (
    <span aria-hidden="true">
      {groups.map((group) =>
        group[0].char === ' ' ? (
          letter(group[0])
        ) : (
          <span key={group[0].i} className="word">
            {group.map(letter)}
          </span>
        )
      )}
    </span>
  )
}

export default AnimatedLetters
